import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from '../../../constants/layout/store/filterSlice';
import moment from 'moment';
import { Placeholder } from 'react-bootstrap';

const AssetAllocationDetails = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Asset Allocation Report"))
    }, [])
    const [searchTerm, setSearchTerm] = useState("");
    const [assetAllocationDetailsListData, setAssetAllocationDetailsListData] = useState([]);
    const [loading, setLoading] = useState(true);

    const columns = {
        TXNName: { text: "Allocation No.", align: "start", visible: true },
        TXNDate: { text: "Allocation Date", align: "center", visible: true },
        RequiTXNName: { text: "Requisition No.", align: "center", visible: true },
        RequiTXNDate: { text: "Req. Date", align: "center", visible: true },
        AllocatedFromName: { text: "Allocated By", align: "start", visible: true },
        AllocatedToName: { text: "Allocated To", align: "start", visible: true },
        AssetName: { text: "Asset", align: "start", visible: true },
        CatName: { text: "Category", align: "start", visible: true },
        BatchNo: { text: "Serial No.", align: "start", visible: true },
        Attributes: { text: "Attributes", align: "start", visible: true },
        Quantity: { text: "Quantity", align: "start", visible: false },

    };

    const [allocatedToOption, setAllocatedToOption] = useState([])
    const [assetOption, setAssetOption] = useState([]);
    const [serialNo, setSerialNoOption] = useState([])

    useEffect(() => {
        fetchGetAssetReturnStatementReport();
    }, []);


    const [apiStatus, SetApiStatus] = useState(undefined);

    const fetchGetAssetReturnStatementReport = async () => {
        SetApiStatus(undefined)
        try {
            const response = await GetServiceCaller(`${API_URL}support-desk-reports/7?P_AssetID=0&P_EmployeeID=0&P_BatchNo=0`);

            if (response.status === 200) {
                SetApiStatus(response?.status);
                const cleanedData = response?.data?.data;
                setAssetAllocationDetailsListData(cleanedData);
                const allocated = response?.data?.employeeList?.map((ele, index) => ({
                    value: ele?.value,
                    label: ele?.text
                }))
                setAllocatedToOption(allocated)
                const assetList = response?.data?.asset?.map((ele, index) => ({
                    value: ele?.value,
                    label: ele?.text
                }))
                setAssetOption(assetList)
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Vendor Master. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Vendor Master:", error);
        }
    };

    const [filterFormData, setFilterData] = useState([]);
    const serial = filterFormData.find((o) => o.label === "Asset")?.value;
    useEffect(() => {

        // Explicitly check for `undefined` or `null` instead of falsy values like 0
        if (serial !== undefined && serial !== null) {
            fetchGetSerioNoDetails(serial);
            setSerialNoOption([]); // Clear category options while fetching new data
        }
    }, [serial]);

    const fetchGetSerioNoDetails = async (id) => {
        try {
            const queryParams = new URLSearchParams({
                AssetID: id,
            });
            const response = await GetServiceCaller(`${API_URL}support-desk/reports/get-serial-no?${queryParams.toString()}`);
            if (response.status === 200) {
                const fetchData = response?.data?.data;
                const serNo = fetchData?.[0]?.BatchNo
                    ? [{ value: fetchData?.[0]?.BatchNo, label: fetchData?.[0]?.BatchNo }]
                    : null;
                setSerialNoOption(serNo)
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch model masters. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("An error occurred while fetching brand details:", error);
        }
    };

    const formDatas = [

        {
            name: "Allocated To",
            type: "Select",
            placeholderText: "Select Employee",
            options: [{ value: "", label: "Select" }, ...allocatedToOption],
        },
        {
            name: "Asset",
            type: "Select",
            placeholderText: "Select Asset",
            options: [{ value: null, label: "Select" }, ...assetOption || []],
        },
        {
            name: "Serial No.",
            type: "Select",
            placeholderText: "Select Serial No",
            options: [{ value: null, label: "Select" }, ...serialNo || []],
        },

    ];

    const handleFilterChange = (e, name) => {
        setFilterData((prevFormData) => {
            // Check if the label already exists
            const existingLabelIndex = prevFormData.findIndex(
                (item) => item.label === name
            );

            // If the label exists, update its value
            if (existingLabelIndex !== -1) {
                const updatedFormData = prevFormData.map((item, index) =>
                    index === existingLabelIndex
                        ? { ...item, value: e.value !== undefined ? e.value : e }
                        : item
                );
                return updatedFormData;
            } else {
                // If the label doesn't exist, add a new label-value pair
                return [
                    ...prevFormData,
                    {
                        label: name,
                        value: e.value !== undefined ? e.value : e, // Assuming e is an event object
                    },
                ];
            }
        });
    };

    const handleGetData = async () => {
        SetApiStatus(undefined)

        try {
            const response = await GetServiceCaller(
                `${API_URL}support-desk-reports/7?P_AssetID=${filterFormData.find((o) => o.label === "Asset")
                    ? filterFormData.find((o) => o.label === "Asset").value
                    : ''
                }&P_EmployeeID=${filterFormData.find((o) => o.label === "Allocated To")
                    ? filterFormData.find((o) => o.label === "Allocated To").value
                    : ''
                }&P_BatchNo=${filterFormData.find((o) => o.label === "Serial No.")
                    ? filterFormData.find((o) => o.label === "Serial No.").value
                    : ''
                }`
            );



            if (response.status === 200) {
                SetApiStatus(response?.status);
                const cleanedData = response?.data?.data;
                setAssetAllocationDetailsListData(cleanedData);
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Disposed Report. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Disposed Report:", error);
        }
    };


    const handleReset = () => {
        setFilterData([])
        fetchGetAssetReturnStatementReport()
    }

    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row">
                        <Dynamic_PR_table
                            data={assetAllocationDetailsListData}
                            columns={columns}
                            itemsPerPage={10}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            handleReset={handleReset}
                            isApiStatus={apiStatus}
                            isSorting={true}
                            isRequiredStatus={true}
                            showIcon1={true}
                            showIcon2={false}
                            isFilterRequired={true}
                            isActionRequired={false}
                            isAddNewBtnRequired={false}
                            formDatas={formDatas}
                            filterFormData={filterFormData}
                            handleGetData={handleGetData}
                            handleChange={handleFilterChange}
                            showIcon3={false}
                            showIcon4={false}
                            showIcon5={false}
                            // handleIcon1={handleEdit}
                            // handleAddNew={handleAddNewVendor}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i class="bi bi-pencil-square icons"></i>,
                                Icon1Text: " Edit",
                                Icon2: <i class="bi bi-trash-fill icons"></i>,
                                Icon3: <i class="bi bi-eye-fill icons"></i>,
                                Icon4: <i class="bi bi-plus-square icons"></i>,
                                Icon4Text: " Add Sub-Contractor",
                            }}
                        />
                    </div>
                </div>

            </div>
        </>
    )
}

export default AssetAllocationDetails;